import { ActionIcon, Alert, Flex, Loader, Text } from '@mantine/core';
import { IconSettings } from '@tabler/icons-react';
import { useEffect } from 'react';

import { TariffCard, useGetVacancyTariffs } from '@entities/vacancy';
import { useSelectTariffModal } from './useSelectTariffModal';

export interface EditVacancyTariffProps {
  value?: string;
  onChange?: (value: string) => void;
  error?: string;
}

export const EditVacancyTariff = ({
  value,
  onChange,
  error,
}: EditVacancyTariffProps) => {
  const { openSelectTariffModal } = useSelectTariffModal();

  const {
    data: tariffs,
    isLoading,
    isError,
    isSuccess,
  } = useGetVacancyTariffs();

  useEffect(() => {
    const unset = value === undefined || value === null || value === '';
    if (isSuccess && tariffs && tariffs.length > 0 && unset) {
      onChange?.(String(tariffs[0].id));
    }
  }, [isSuccess, tariffs, value, onChange]);

  const selectedTariff = tariffs?.find(
    tariff => tariff.id.toString() === value?.toString()
  );

  return (
    <Flex
      direction='column'
      gap={24}
      p={24}
      w='100%'
      bg='primary.0'
      style={{
        borderRadius: 16,
        overflow: 'hidden',
        outline: error ? '1px solid var(--mantine-color-red-6)' : 'none',
      }}
    >
      <Flex
        justify='space-between'
        align='center'
        w='100%'
        wrap='nowrap'
        gap='md'
      >
        <Text c='primary.7' size='lg' fw={600}>
          Тариф
        </Text>
        <Flex gap={16} align='center'>
          <ActionIcon
            size={32}
            variant='transparent'
            onClick={() => {
              if (!tariffs?.length) {
                return;
              }
              openSelectTariffModal({
                tariffs,
                selectedTariffId: value,
                onConfirm: id => onChange?.(String(id)),
              });
            }}
            aria-label='Выбор тарифа'
            disabled={!isSuccess || !tariffs?.length}
          >
            <IconSettings size={24} color='var(--mantine-color-secondary-7)' />
          </ActionIcon>
        </Flex>
      </Flex>

      {isLoading && (
        <Flex justify='center' py='xl'>
          <Loader color='primary' />
        </Flex>
      )}

      {isError && (
        <Alert
          color='red'
          title='Не удалось загрузить тарифы'
          variant='light'
        />
      )}

      {isSuccess && tariffs?.length === 0 && (
        <Text c='tertiary.7' fz={14}>
          Нет доступных тарифов
        </Text>
      )}

      {isSuccess && selectedTariff && <TariffCard tariff={selectedTariff} />}

      {error && (
        <Text c='red' size='sm'>
          {error}
        </Text>
      )}
    </Flex>
  );
};
